import { Component, OnInit, Input } from '@angular/core';
import { ConfigurationService } from './../../services/configuration.service';
import { TranslatesService } from './../../services/translates.service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {

  @Input() title = '';
  @Input() additionalText = '';
  @Input() tripId = -1;

  constructor(public configurationService: ConfigurationService, public translate: TranslatesService) { }

  ngOnInit() {
  }

  public setLanguage(lang) {
    this.configurationService.setLanguage(lang);
    window.location.reload();
  }

}



// WEBPACK FOOTER //
// G:/Projekty/swaythegame/src/app/shared-components/toolbar/toolbar.component.ts